const SIDENAV_COLLAPSED_KEY = "secops:console:sidenav-collapsed";

// Primary-sidenav collapse preference. Client-only: a layout choice never leaves the
// browser, so there is no account row, no RPC, and nothing to leak across a workspace
// switch or a support session. (The CAD rail prefs this once mirrored retired with the
// map-first glass desk; the rails themselves are gone.)

function readBoolean(key: string, fallback: boolean): boolean {
  try {
    const stored = window.localStorage?.getItem(key);
    if (stored === "true") {
      return true;
    }
    if (stored === "false") {
      return false;
    }
  } catch {
    // Ignore private mode / disabled storage.
  }
  return fallback;
}

function writeBoolean(key: string, value: boolean): void {
  try {
    window.localStorage?.setItem(key, value ? "true" : "false");
  } catch {
    // Ignore.
  }
}

/** Expanded until the supervisor chooses otherwise - the rail should not shrink unasked. */
export function readSidenavCollapsed(): boolean {
  return readBoolean(SIDENAV_COLLAPSED_KEY, false);
}

export function writeSidenavCollapsed(collapsed: boolean): void {
  writeBoolean(SIDENAV_COLLAPSED_KEY, collapsed);
}
